import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import useService from "../../../Hooks/useService";
import ContentLayout from "../../../Layout/ContentLayout";
import ServiceResult, { Loaders, } from "../../../UI/ServiceResult/ServiceResult";
import CustomCard from "../../../UI/CustomCard/CustomCard";
import InfoItems from "../../../UI/InfoItems/InfoItems";
import DateService from "../../../../Services/Shared/Date.service";
import PageTitle from "../../../UI/PageTitle/PageTitle";
import { getLmsImportErrorIndexPath } from "./LmsImportErrorRoutes";
import LmsImportErrorService from "../../../../Services/LmsImportError.service";
const LmsImportErrorDetail = () => {
    const params = useParams();
    const id = parseInt(params.id, 10);
    const [lmsImportErrorState, loadLmsImportError] = useService(LmsImportErrorService.get);
    useEffect(() => {
        if (id) {
            loadLmsImportError(id);
        }
    }, [loadLmsImportError, id]);
    return (_jsx(ContentLayout, { paddingTop: true, paddingBottom: true, className: "fullMinHeightMinusPrimaryNav", children: _jsx(ServiceResult, { loader: Loaders.overlay(), state: lmsImportErrorState, children: (lmsImportError) => (_jsxs(_Fragment, { children: [_jsxs(PageTitle, { className: "pb-2", children: [_jsx(Link, { to: getLmsImportErrorIndexPath(), className: "text-decoration-none pr-2", title: "Back to enrollment import errors", children: _jsx("span", { className: "fal fa-arrow-circle-left" }) }), lmsImportError.id] }), _jsx(CustomCard, { title: "Details", className: "mt-3", children: _jsx("div", { className: "card-body", children: _jsx(InfoItems, { numColumnsLg: 1, numColumnsMd: 1, numColumnsSmAndSmaller: 1, items: [
                                    {
                                        label: "Student LMS ID",
                                        value: lmsImportError.studentLmsId,
                                    },
                                    {
                                        label: "Student Username",
                                        value: lmsImportError.studentUsername,
                                    },
                                    {
                                        label: "Course Section ID",
                                        value: lmsImportError.courseSectionId,
                                    },
                                    {
                                        label: "Course Section SIS ID",
                                        value: lmsImportError.courseSectionSisId,
                                    },
                                    {
                                        label: "Current Grade",
                                        value: lmsImportError.courseSectionSisId,
                                    },
                                    {
                                        label: "Created Date",
                                        value: DateService.displayLongWithTimeWithoutWeekday(lmsImportError.dateCreated),
                                    },
                                    {
                                        label: "Imported Row",
                                        value: lmsImportError.importedRow,
                                    },
                                ] }) }) })] })) }) }));
};
export default LmsImportErrorDetail;
